import { useOrganizationCreate } from '../../../libs/ohat-api';
import { Card, Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { CreateOrganizationDto } from '@models/createOrganizationDto';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { UpdateOrganizationDto } from '@models/updateOrganizationDto';
import { OrganizationForm } from './form/OrganizationForm';

export function CreateOrganizationPage() {
  const { t } = useTranslation();
  const auth = useAuth();
  const navigate = useNavigate();
  const { mutateAsync: createOrganization } = useOrganizationCreate();

  const onSubmit = async (
    values: CreateOrganizationDto | UpdateOrganizationDto,
  ) => {
    const param = values as CreateOrganizationDto;
    // 組織への所属と owner ロールの付与はAPI側で組織作成と同一トランザクションで行う。
    // ここでアカウントを更新すると、所属だけ先に走って owner にならない組織ができうる。
    await createOrganization({ data: param });
    await auth.fetchAccount(auth.account!.sub);
    navigate('/');
  };

  return (
    <Row gutter={[16, 8]} style={{ flex: 1, justifyContent: 'center' }}>
      <Col lg={8} md={12} sm={16} xs={24}>
        <Card title={t('org.register')}>
          <OrganizationForm onSubmit={onSubmit} />
        </Card>
      </Col>
    </Row>
  );
}
